declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

type ClarityTag = {
  key: string;
  value: string;
};

const trackClarity = (tags: ClarityTag[]) => {
  if (typeof window.clarity === 'function') {
    tags.forEach(({ key, value }) => {
      window.clarity!('set', key, value);
    });
  }
};

export const useClarityTracking = () => {
  // Form tracking
  const trackFormStep = (step: number, source: 'cta' | 'video_overlay') => {
    trackClarity([
      { key: 'form_step', value: String(step) },
      { key: 'form_source', value: source },
    ]);
  };

  const trackDealVolume = (option: string) => {
    trackClarity([{ key: 'deal_volume', value: option }]);
  };

  const trackBudget = (option: string) => {
    trackClarity([{ key: 'budget', value: option }]);
  };

  const trackFormSubmit = (source: 'cta' | 'video_overlay' | 'booking') => {
    trackClarity([
      { key: 'form_submit', value: source },
    ]);
  };

  const trackDisqualified = (reason: string) => {
    trackClarity([
      { key: 'disqualified', value: 'true' },
      { key: 'disqualify_reason', value: reason },
    ]);
  };

  // Video tracking
  const trackVideoPlay = () => {
    trackClarity([{ key: 'video_play', value: 'true' }]);
  };

  const trackVideoMilestone = (percentage: number) => {
    trackClarity([{ key: 'video_milestone', value: String(percentage) }]);
  };

  const trackVideoPaused = () => {
    trackClarity([{ key: 'video_paused', value: 'true' }]);
  };

  const trackVideoFullscreen = () => {
    trackClarity([{ key: 'video_fullscreen', value: 'toggled' }]);
  };

  // Booking tracking
  const trackBookingDate = (date: string) => {
    trackClarity([{ key: 'booking_date', value: date }]);
  };

  const trackBookingTime = (time: string) => {
    trackClarity([{ key: 'booking_time', value: time }]);
  };

  const trackBookingSubmitted = () => {
    trackClarity([{ key: 'booking_submitted', value: 'true' }]);
  };

  // Conversion tracking
  const trackConversionComplete = () => {
    trackClarity([{ key: 'conversion_complete', value: 'true' }]);
  };

  return {
    trackFormStep,
    trackDealVolume,
    trackBudget,
    trackFormSubmit,
    trackDisqualified,
    trackVideoPlay,
    trackVideoMilestone,
    trackVideoPaused,
    trackVideoFullscreen,
    trackBookingDate,
    trackBookingTime,
    trackBookingSubmitted,
    trackConversionComplete,
  };
};

export default useClarityTracking;
